/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Tab1Inputs */

const zh_landing_admin_tab1 = /** @type {(inputs: Landing_Admin_Tab1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`智能学习材料`)
};

const en_landing_admin_tab1 = /** @type {(inputs: Landing_Admin_Tab1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart study materials`)
};

const es_landing_admin_tab1 = /** @type {(inputs: Landing_Admin_Tab1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materiales inteligentes`)
};

/**
* | output |
* | --- |
* | "Smart study materials" |
*
* @param {Landing_Admin_Tab1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_admin_tab1 = /** @type {((inputs?: Landing_Admin_Tab1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Tab1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_tab1(inputs)
	if (locale === "en") return en_landing_admin_tab1(inputs)
	return es_landing_admin_tab1(inputs)
});